// extracted by mini-css-extract-plugin
export default {"documents":"AgentDocuments_documents__V-7cX","documents__container":"AgentDocuments_documents__container__L8-O1"};